import * as React from 'react';

import { IInputChangeEventHandler } from '../../../../interfaces';

interface IProps {
    name: string,
    label: string,
    checked: boolean,
    onChange: React.EventHandler<React.ChangeEvent<HTMLInputElement>>,
}

export default class CheckboxInput extends React.Component<IProps, void> {
    static propTypes = {
        name: React.PropTypes.string.isRequired,
        label: React.PropTypes.string.isRequired,
        checked: React.PropTypes.bool,
        onChange: React.PropTypes.func.isRequired,
    };

    render() {
        const { onChange, name, label, checked } = this.props;

        return (
            <div className="checkbox">
                <label>
                    <input
                        type="checkbox"
                        name={name}
                        checked={checked}
                        onChange={onChange}
                    />
                    {label}
                </label>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/common/Input/CheckboxInput.tsx